import React, { Component } from 'react';
import PropTypes from 'prop-types';
import scrollToComponent from 'react-scroll-to-component-ssr';
import map from 'lodash/map';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { FavoriteWrapper, FavoritesButton } from 'subsys/favorites';
import InteractiveComponent from 'components/interactive-fly-component';
import Row, { Col } from 'components/row';
import Container from 'components/container';
import { iconTypes } from 'components/icon';
import sensor from 'components/sensor';
import Image, { OpenGraphImage } from 'components/image';
import Slick from 'components/slick-slider';

import { renderMinPrice } from 'src-sites/bild/section-project/render-min-price';
import { getImages } from 'src-sites/bild/section-project/get-images';
import getHeaderHeight from 'src-sites/bild/section-project/get-header-height';

import renderRightColumn from './render-right-column';
import blockDescriptionProblem from './blocks/block-description-problem';
import blockDescription from './blocks/block-description';
import blockCreators from './blocks/block-creators';
import blockMakeOrder from './blocks/block-make-order';

import translates from './project-i18n';

import NotificationFavorite from '../body/notification-favorite';

const bemClasses = new Bem('project');

@sensor
@I18nHoc(translates())
export default class Project extends Component {
  static propTypes = {
    project: PropTypes.shape({
      advanced_info: PropTypes.shape({}),
      stocks: PropTypes.shape({}),
      salers: PropTypes.arrayOf(PropTypes.shape({})),
      display_name: PropTypes.string,
      display_path: PropTypes.string,
      location_path: PropTypes.string,
      points: PropTypes.shape({}),
    }),
    seoData: PropTypes.shape({}),
    creators: PropTypes.arrayOf(PropTypes.shape({})),
    makeOrderType: PropTypes.shape({}),
    orderStatus: PropTypes.shape({}),
    stocksLC: PropTypes.shape({}),
    promocode: PropTypes.string,
    // Billing order id
    orderId: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.getInteractiveComponents = this.getInteractiveComponents.bind(this);
    this.handleUpdateOrder = this.handleUpdateOrder.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.state = {
      device: 'desktop',
      tagsTabSelected: 0,
      updateOrder: false
    };
  }

  componentDidMount() {
    this.scrollTo(this.sensor.getRuntime());
    this.onHandleResize(this.sensor.getRuntime());
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;
    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  getInteractiveComponents(favData) {
    const { project } = this.props;
    const index = findIndex(favData, { entity_id: project.id });

    return (
      <InteractiveComponent
        {...bemClasses('favorite')}
        iconType={iconTypes.favoritesBorder}
        newIconType={iconTypes.favorites}
        destinationPoint="favoritesIcon"
      >
        <FavoritesButton
          project="bildcontrol"
          entity="location"
          entityId={project.id}
          subgroup="living_complex"
          inFavorites={index > -1}
          renderNotification={<NotificationFavorite />}
          hideLabel
        />
      </InteractiveComponent>
    );
  }

  scrollTo() {
    const headerHeight = getHeaderHeight.call(this);
    scrollToComponent(this.makeOrderRef, { offset: -headerHeight, align: 'top', duration: 300, ease: 'linear' });
  }

  handleUpdateOrder() {
    this.setState({ updateOrder: !this.state.updateOrder });
  }

  renderImage(data) {
    const { images: { bild } = {} } = data;
    if (!bild || !bild.length) {
      return (
        <Image
          {...bemClasses('imgPic')}
          image={{}}
        />
      );
    }

    return (
      <Slick {...bemClasses('imgPic')}>
        {map(bild, (img, index) => (
          <Image
            key={index}
            image={getImages.call(this, img).titleImage}
            group={data.display_name}
            fullScreenSwitch="click"
          />
        ))}
      </Slick>
    );
  }

  render() {
    const { project = {}, seoData, creators } = this.props;
    const {
      advanced_info = {}, display_name = '', display_path, location_path, problem_desc,
      title_image, ...rest
    } = project;
    const propsGroup = { ...advanced_info, ...rest };
    const fullAddress = get(propsGroup, 'fullAddress.address', null);
    const header = fullAddress || display_path || location_path;
    const { min_price, completion } = propsGroup;
    const imageId = get(title_image, 'id');
    const livingComplexDescription = get(propsGroup, 'reliability_description');
    const topic = seoData && seoData.header ? seoData.header : display_name;
    const toponymLabel = (
      <div {...bemClasses('location')}>
        {header &&
          <div {...bemClasses('address')}>
            <span {...bemClasses('text')}>
              {header}
            </span>
          </div>
        }
      </div>
    );

    return (
      <>
        <OpenGraphImage imageId={imageId} />
        <Container body>
          <div {...bemClasses('img', 'main')}>
            {this.renderImage(project)}
            <div {...bemClasses('onPhoto', 'info')}>
              <div {...bemClasses('onPhotoOverlay', 'bottom')}>
                <div {...bemClasses('title')}>
                  <div {...bemClasses('text')}><h1 children={topic} /></div>
                </div>
                <div {...bemClasses('info')}>
                  {toponymLabel}
                  {renderMinPrice.call(this, bemClasses, min_price, {}, null, ['minPrice'], { priceMain: true })}
                </div>
              </div>
            </div>
            <FavoriteWrapper project="bildcontrol" entity="location">
              {({ data }) => this.getInteractiveComponents(data)}
            </FavoriteWrapper>
          </div>
          <Row {...bemClasses('row', 'imgAfter')} mpColumn>
            <Col {...bemClasses('col', 'left')} allPr={0}>
              {blockDescriptionProblem(bemClasses, problem_desc)}
              {blockDescription(bemClasses, completion)}
              {blockDescription(bemClasses, livingComplexDescription)}
              {blockCreators.call(this, creators)}
            </Col>
            <Col {...bemClasses('col', 'right')} allAuto allPr={0}>
              {renderRightColumn.call(this, project)}
            </Col>
          </Row>
        </Container>
        {blockMakeOrder.call(this)}
      </>
    );
  }
}
